module.exports = __webpack_public_path__ + "static/media/Wolfjerky.1756c95c.png";